import { ContainerModule } from 'inversify';
import SocketConnection from '@framework/di/Providers/Socket/Connection';
import { ISocketAdapter, ISocketClient, ISocketConnection, ISocketDispatcher } from './interfaces';
import DITypes from './types';
import { SocketAdapter } from '../SocketAdapter';
import { SocketDispatcherFactory } from '../SocketDispatcherFactory';
import SocketClient from '../SocketClient';

export const SocketModule = new ContainerModule(({ bind }) => {
  bind<ISocketConnection>(DITypes.SocketConnection).to(SocketConnection).inSingletonScope();

  bind<ISocketAdapter>(DITypes.SocketAdapter).to(SocketAdapter).inSingletonScope();

  bind<ISocketDispatcher>(DITypes.SocketDispatcher)
    .toDynamicValue(({ get }) => {
      const factory = get<SocketDispatcherFactory>(DITypes.SocketDispatcherFactory);
      const socketAdapter = get<ISocketAdapter>(DITypes.SocketAdapter);
      return factory.create(socketAdapter);
    })
    .inSingletonScope();

  bind<SocketDispatcherFactory>(DITypes.SocketDispatcherFactory).to(SocketDispatcherFactory).inSingletonScope();

  bind<ISocketClient>(DITypes.SocketClient).to(SocketClient).inSingletonScope();
});
